// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const PreviousDiscountsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 80px;
`;
export const Title = styled.text`
  font-size: 30px;
  color: ${COLORS.cornflowerBlue};
  margin-bottom: 30px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 595px;
  max-height: 120px;
  margin-bottom: 80px;
  background: ${COLORS.primaryWhite};
  padding: 20px 30px 30px 30px;
  border-radius: 10px;
`;
export const DiscountsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const InputAtomContainer = styled.div`
  width: 300px;
`;
export const ButtonAtomContainer = styled.div``;
export const PaginationContainer = styled.div`
  position: absolute;
  bottom: 3%;
  right: 3%;
`;
